(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sbc-giveaway-wheel"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root){
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';
  const canvas = root.querySelector('[data-wheel]');
  const ctx = canvas.getContext('2d');
  const startBtn = root.querySelector('[data-start]');
  const stopBtn = root.querySelector('[data-stop]');
  const resumeBtn = root.querySelector('[data-resume]');
  const resetBtn = root.querySelector('[data-reset]');
  const overlay = root.querySelector('[data-overlay]');
  const overlayKicker = root.querySelector('[data-overlay-kicker]');
  const overlayTitle = root.querySelector('[data-overlay-title]');
  const overlaySub = root.querySelector('[data-overlay-sub]');
  const status = root.querySelector('[data-status]');
  const roundEl = root.querySelector('[data-round]');
  const aliveEl = root.querySelector('[data-alive]');
  const outEl = root.querySelector('[data-out]');
  const progressEl = root.querySelector('[data-progress]');
  const recentEl = root.querySelector('[data-recent]');
  const topEl = root.querySelector('[data-top]');
  const topCard = root.querySelector('[data-top-card]');

  const first = ['Max','Lena','Timo','Sarah','Chris','Nina','Alex','Mara','Jonas','Lea','Ben','Laura','Tom','Julia','Felix','Anna','Jan','Lisa','Paul','Mia'];
  const tags = ['180','Bull','Checkout','Flight','Barrel','Darts','Double','Treble','SBC','Board','Nuke','Finish','Grip','Point','Throw','Nine','Game','Arrow','Top','Leg','Set','Match','Pro','Steel','Dart'];
  const bonusNames = ['25 € Gutschein','50 € Gutschein','100 € Gutschein'];
  let players, angle, spinning, paused, currentAnim, recent, topPlacements, audioCtx, tickTimer;

  function makePlayers(){
    const arr=[];
    for(let i=0;i<500;i++){
      let name = first[i%first.length] + tags[Math.floor(i/first.length)%tags.length];
      if(i===30) name='DartKing87';
      if(i===31) name='DartKing87';
      if(i===120) name='MaximilianDartPro2026'.slice(0,20);
      arr.push({id:i+1,name,bonus:null});
    }
    const bonusSlots=[99,249,499];
    bonusSlots.forEach((idx,j)=>arr[idx].bonus=bonusNames[j]);
    return arr;
  }

  function reset(){
    players=makePlayers(); angle=0; spinning=false; paused=false; currentAnim=null; recent=[]; topPlacements=[];
    startBtn.disabled=false; stopBtn.disabled=true; resumeBtn.hidden=true; overlay.hidden=true; topCard.hidden=true;
    status.textContent='Bereit für den ersten Test.';
    recentEl.innerHTML=''; topEl.innerHTML='';
    updateUI(); draw();
  }

  function updateUI(){
    const out=500-players.length;
    roundEl.textContent='Runde '+Math.min(out+1,500);
    aliveEl.textContent=players.length;
    outEl.textContent=out;
    progressEl.style.width=(out/499*100)+'%';
    if(players.length<=10){topCard.hidden=false;renderTop();}
  }

  function renderTop(){
    topEl.innerHTML='';
    players.forEach(p=>{
      const li=document.createElement('li');
      li.textContent=p.name+(p.bonus?' · ZUSATZPREIS':'');
      topEl.appendChild(li);
    });
    topPlacements.slice().reverse().forEach(x=>{
      const li=document.createElement('li');
      li.textContent=x.place+'. '+x.name+' – ausgeschieden'+(x.bonus?' · '+x.bonus+' gewonnen':'');
      topEl.appendChild(li);
    });
  }

  function renderRecent(){
    recentEl.innerHTML='';
    recent.slice(-10).reverse().forEach(x=>{
      const li=document.createElement('li');
      li.textContent=x.place+'. '+x.name+(x.bonus?' – '+x.bonus+' gewonnen':'');
      recentEl.appendChild(li);
    });
  }

  function draw(){
    const w=canvas.width,h=canvas.height,cx=w/2,cy=h/2,r=w*.46;
    ctx.clearRect(0,0,w,h);
    if(!players.length)return;
    const step=Math.PI*2/players.length;
    ctx.save();ctx.translate(cx,cy);ctx.rotate(angle);
    players.forEach((p,i)=>{
      const a=i*step-Math.PI/2;
      ctx.beginPath();ctx.moveTo(0,0);ctx.arc(0,0,r,a,a+step);ctx.closePath();
      ctx.fillStyle=p.bonus?'#c9a227':(i%2?'#242424':'#171717');ctx.fill();
      ctx.strokeStyle=players.length<80?'#555':'#303030';ctx.lineWidth=players.length<80?1.5:.45;ctx.stroke();
      if(players.length<=80){
        ctx.save();ctx.rotate(a+step/2);ctx.translate(r*.62,0);ctx.rotate(Math.PI/2);
        ctx.fillStyle=p.bonus?'#111':'#f2f2f2';
        ctx.font=(players.length<=10?'700 24px':'600 11px')+' Arial';
        ctx.textAlign='center';ctx.textBaseline='middle';
        const label=p.bonus&&players.length>10?'ZUSATZPREIS':p.name;
        ctx.fillText(label,0,0,Math.max(80,r*.52));
        ctx.restore();
      }
    });
    ctx.restore();
    ctx.beginPath();ctx.arc(cx,cy,r*.11,0,Math.PI*2);ctx.fillStyle='#111';ctx.fill();ctx.lineWidth=8;ctx.strokeStyle='#c9a227';ctx.stroke();
    ctx.fillStyle='#fff';ctx.font='900 24px Arial';ctx.textAlign='center';ctx.textBaseline='middle';ctx.fillText('SBC',cx,cy);
  }

  function sleep(ms){return new Promise(r=>setTimeout(r,ms))}
  function tick(){
    try{
      audioCtx ||= new (window.AudioContext||window.webkitAudioContext)();
      const o=audioCtx.createOscillator(),g=audioCtx.createGain();
      o.frequency.value=700;g.gain.value=.025;o.connect(g);g.connect(audioCtx.destination);o.start();o.stop(audioCtx.currentTime+.025);
    }catch(e){}
  }

  async function countdown(){
    overlay.hidden=false;overlayKicker.textContent='START';overlaySub.textContent='';
    for(let i=10;i>=1;i--){
      overlayTitle.textContent=i;
      if(i<=3)tick();
      await sleep(1000);
      if(paused) return false;
    }
    overlay.hidden=true;return true;
  }

  async function spin(){
    if(paused||players.length<=1)return;
    spinning=true;stopBtn.disabled=false;
    const duration=players.length<=10?10000:3000;
    const minTurns=players.length<=10?3:5;
    const extra=Math.random()*Math.PI*2;
    const startAngle=angle;
    const total=minTurns*Math.PI*2+extra;
    const started=performance.now();
    let lastTick=0;
    await new Promise(resolve=>{
      function frame(now){
        if(paused){currentAnim={startAngle,total,duration,elapsed:Math.min(duration,now-started)};spinning=false;resolve();return;}
        const t=Math.min(1,(now-started)/duration);
        const eased=1-Math.pow(1-t,2);
        angle=startAngle+total*eased;
        if(now-lastTick>Math.max(24,70*t)){tick();lastTick=now;}
        draw();
        if(t<1)requestAnimationFrame(frame);else resolve();
      }
      requestAnimationFrame(frame);
    });
    if(paused)return;
    spinning=false;currentAnim=null;
    await eliminate();
  }

  async function resumeSpin(){
    if(!currentAnim)return;
    const a=currentAnim;currentAnim=null;spinning=true;paused=false;resumeBtn.hidden=true;stopBtn.disabled=false;status.textContent='Ziehung läuft.';
    const remain=Math.max(1,a.duration-a.elapsed),startAngle=angle;
    const progressed=1-Math.pow(1-a.elapsed/a.duration,2);
    const remainingTotal=a.total*(1-progressed);
    const started=performance.now();
    await new Promise(resolve=>{
      function frame(now){
        if(paused){currentAnim={startAngle:a.startAngle,total:a.total,duration:a.duration,elapsed:a.elapsed+Math.min(remain,now-started)};spinning=false;resolve();return;}
        const t=Math.min(1,(now-started)/remain);
        const eased=1-Math.pow(1-t,2);
        angle=startAngle+remainingTotal*eased;draw();
        if(t<1)requestAnimationFrame(frame);else resolve();
      }
      requestAnimationFrame(frame);
    });
    if(!paused){spinning=false;await eliminate();}
  }

  async function eliminate(){
    const step=Math.PI*2/players.length;
    const normalized=(((-angle)%(Math.PI*2))+(Math.PI*2))%(Math.PI*2);
    const idx=Math.floor(normalized/step)%players.length;
    const p=players[idx];
    const place=players.length;
    const wasEleven=players.length===11;
    players.splice(idx,1);
    recent.push({name:p.name,place,bonus:p.bonus});
    if(place<=10)topPlacements.push({name:p.name,place,bonus:p.bonus});
    overlay.hidden=false;overlayKicker.textContent=p.bonus?'ZUSATZPREIS':'AUSGESCHIEDEN';overlayTitle.textContent=p.name;overlaySub.textContent=p.bonus?p.bonus:['RAUS!','Heute leider nicht.','Abflug!'][Math.floor(Math.random()*3)];
    updateUI();renderRecent();draw();
    await sleep(1000);
    if(p.bonus){overlayKicker.textContent='ZUSATZPREIS GEWONNEN';overlayTitle.textContent=p.name;overlaySub.textContent=p.bonus;await sleep(10000);}
    overlay.hidden=true;
    if(wasEleven){
      overlay.hidden=false;overlayKicker.textContent='TOP 10';overlayTitle.textContent='Jetzt wird’s ernst!';overlaySub.textContent='';await sleep(3000);overlay.hidden=true;
    }
    if(players.length===1){
      const winner=players[0];progressEl.style.width='100%';overlay.hidden=false;overlayKicker.textContent='LAST MAN STANDING';overlayTitle.textContent=winner.name;overlaySub.textContent='Hauptpreis gewonnen'+(winner.bonus?' + '+winner.bonus:'');status.textContent='Testziehung abgeschlossen.';stopBtn.disabled=true;return;
    }
    if(paused)return;
    if(players.length<=10&&!p.bonus)await sleep(3000);
    spin();
  }

  startBtn.addEventListener('click',async()=>{
    if(spinning||players.length<2)return;
    startBtn.disabled=true;status.textContent='10-Sekunden-Countdown läuft.';
    const ok=await countdown();if(!ok)return;
    status.textContent='Ziehung läuft.';spin();
  });
  stopBtn.addEventListener('click',()=>{
    if(!spinning)return;
    paused=true;status.textContent='Ziehung vorübergehend pausiert';stopBtn.disabled=true;resumeBtn.hidden=false;
  });
  resumeBtn.addEventListener('click',()=>{ if(currentAnim)resumeSpin(); });
  resetBtn.addEventListener('click',()=>{paused=true;setTimeout(reset,50)});
  reset();
  }
  function boot(){
    document.querySelectorAll('.sbc-giveaway:not([data-ready])').forEach(init);
  }
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',boot,{once:true});
  }else{
    boot();
  }
  document.addEventListener('shopify:section:load',boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sbc-work-showcase"] && !Shopify.designMode) return;
  try {
    
function initSbcShowcase(root){
  if(!root || root.dataset.ready === '1') return;
  root.dataset.ready = '1';

  const track = root.querySelector('.sbc-work-track');
  const seed = root.querySelector('.sbc-work-seed');
  const prev = root.querySelector('.sbc-work-prev');
  const next = root.querySelector('.sbc-work-next');
  let originals = Array.from(seed.children);

  if(originals.length < 2) return;

  for(let i = originals.length - 1; i > 0; i--){
    const j = Math.floor(Math.random() * (i + 1));
    const tmp = originals[i];
    originals[i] = originals[j];
    originals[j] = tmp;
  }

  seed.replaceChildren(...originals);

  const singleSet = seed.innerHTML;
  seed.innerHTML = singleSet + singleSet + singleSet + singleSet + singleSet;

  const count = originals.length;
  let setWidth = 0;
  let step = 0;
  let wrapping = false;

  function measure(){
    const all = seed.children;
    if(all.length < count * 5) return false;
    step = all[1].offsetLeft - all[0].offsetLeft;
    setWidth = all[count].offsetLeft - all[0].offsetLeft;
    return step > 0 && setWidth > 0;
  }

  function center(){
    if(!measure()) return;
    track.scrollLeft = setWidth * 2;
    track.classList.add('is-ready');
  }

  function wrap(){
    if(wrapping || !setWidth) return;
    const x = track.scrollLeft;
    if(x < setWidth * 1.5 || x > setWidth * 3.5){
      wrapping = true;
      track.scrollLeft = x + (x < setWidth * 1.5 ? setWidth * 2 : -setWidth * 2);
      requestAnimationFrame(function(){ wrapping = false; });
    }
  }

  track.addEventListener('scroll', wrap, {passive:true});
  track.addEventListener('scrollend', wrap, {passive:true});
  track.addEventListener('touchend', wrap, {passive:true});
  track.addEventListener('pointerup', wrap, {passive:true});

  prev.addEventListener('click', function(){
    wrap();
    track.scrollBy({left: -(step || 180), behavior: 'smooth'});
  });

  next.addEventListener('click', function(){
    wrap();
    track.scrollBy({left: (step || 180), behavior: 'smooth'});
  });

  requestAnimationFrame(function(){
    requestAnimationFrame(center);
  });
}

document.querySelectorAll('[data-sbc-showcase]').forEach(initSbcShowcase);
document.addEventListener('shopify:section:load', function(event){
  const root = event.target.querySelector('[data-sbc-showcase]') || (event.target.matches && event.target.matches('[data-sbc-showcase]') ? event.target : null);
  if(root) initSbcShowcase(root);
});

  } catch(e) { console.error(e); }
})();
})();
